import styled from 'styled-components';

export const FeedbackButtonContainer = styled.button`
  background: none;
  border: none;
  padding: 0;
  font: inherit;
  cursor: pointer;
  outline: inherit;
`;
